export interface StorageDashboardMount {
  id: string;
  displayName: string;
  kind: string;
  accessMode: string;
}

export interface StorageDashboardActivitySummary {
  totalChanges: number;
  uploads: number;
  renames: number;
  deletes: number;
}

export interface StorageDashboardActivityItem {
  id: string;
  occurredAt: string;
  operation: string;
  mountId: string;
  mountDisplayName: string;
  path: string;
  userName: string | null;
}

export interface StorageDashboardFileItem {
  mountId: string;
  mountDisplayName: string;
  path: string;
  name: string;
  lastModified: string | null;
  sizeBytes: number | null;
}

export interface StorageDashboardSummary {
  generatedAt: string;
  mounts: StorageDashboardMount[];
  writableMountCount: number;
  activityLast7Days: StorageDashboardActivitySummary;
  recentActivity: StorageDashboardActivityItem[];
  filesUpdatedLast7Days: number;
  filesListedAtRoots: number;
  latestFiles: StorageDashboardFileItem[];
}

export type StorageDashboardCardId = 'storageAccess' | 'recentActivity' | 'latestFiles';

export const STORAGE_DASHBOARD_CARDS: { id: StorageDashboardCardId; title: string }[] = [
  { id: 'storageAccess', title: 'Your Storage' },
  { id: 'recentActivity', title: 'Recent Activity' },
  { id: 'latestFiles', title: 'Latest Files' }
];

export const DEFAULT_STORAGE_DASHBOARD_ORDER: StorageDashboardCardId[] = STORAGE_DASHBOARD_CARDS.map(
  (x) => x.id
);
